"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Index = void 0;
var _react = _interopRequireDefault(require("react"));
var _BrandLogo = _interopRequireDefault(require("./BrandLogo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Index = props => {
  // A toggle between 'glitch' & 'glitch2' for class animation variants
  var [glitchVariant, setGlitchVariant] = _react.default.useState('glitch');

  // Any time glitchTimeout is changed, set a new Timeout for glitch
  _react.default.useEffect(() => {
    var randomGlitchTimer = setInterval(() => {
      var newGlitch = glitchVariant === 'glitch' ? 'glitch2' : 'glitch';
      setGlitchVariant(newGlitch);
    }, getNewRandomTimeout());

    // clean up any lingering timers on-unmount
    return () => clearInterval(randomGlitchTimer);
  }, [glitchVariant]);
  var getNewRandomTimeout = () => {
    return (Math.floor(Math.random() * 30) + 4) * 1000;
  };
  return /*#__PURE__*/_react.default.createElement(_BrandLogo.default, _extends({}, props, {
    glitchClassVariant: glitchVariant
  }));
};
exports.Index = Index;
var _default = exports.default = Index;